/***** Begin bsSocialModule Scripts *****/

var bsSocialModule = {

  scrollToTop: function()
  {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

};

/***** End bsSocialModule Scripts *****/